import React, { useEffect, useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useAppVersionGate } from "../../hooks/useAppVersionGate";

// 新ビルドの公開を検知したら再読み込みを促すダイアログ。
// 「あとで」で閉じられるが、タブへ戻ってきたタイミングで再表示する。
// 古いまま操作を続けても、注文確定・カート追加はトランザクション内の検査で止まる。
const AppVersionGateDialog = () => {
  const { isUpdateAvailable, reloadNow } = useAppVersionGate();
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    if (!isUpdateAvailable) {
      return undefined;
    }
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsDismissed(false);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, [isUpdateAvailable]);

  return (
    <Dialog
      open={isUpdateAvailable && !isDismissed}
      onClose={() => setIsDismissed(true)}
    >
      <DialogTitle>新しいバージョンが公開されました</DialogTitle>
      <DialogContent>
        <DialogContentText>
          最新の状態でご利用いただくため、ページを再読み込みしてください。
          再読み込みするまで、注文の確定とカートへの追加はご利用いただけません。
          (カートの中身は再読み込みしても消えません)
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => setIsDismissed(true)}>あとで</Button>
        <Button variant="contained" color="primary" onClick={reloadNow}>
          今すぐ更新
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AppVersionGateDialog;
